
import React, { useState, useEffect } from 'react'
import { HumanTime } from '@/components/commons/HumanTime'

import commonsService from '@/services/commons.service'
import { useScroll } from '@/core/hooks/useFeedScroll'
import store from '@/core/store'
import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'
import { MessageAttachmentsSection } from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MessageAttachmentsSection/MessageAttachmentsSection'
import { MainSectionHTML } from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MainSectionHTML/MainSectionHTML'
import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon.svg'
import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon-2.svg'

import classNames from 'classnames'
import sessionService from '@/app-domains/user/session/session.service'
import WritingModalService from '@/app-domains/messages/writing/WritingModal.service'
import { useDeviceSelectors } from 'react-device-detect'

import './DraftsList.scoped.sass'
import NoMessagesComponent from '../FeedContent/NoMessagesComponent'
import { ViewMenu } from '@/components/ViewMenu/ViewMenu'
import { ReactComponent as BarsIcon } from '@/assets/icons/bars-icon.svg'
import { ReactComponent as DoubleBarIcon } from '@/assets/icons/double-bar-icon.svg'

function DraftListItem (props) {
  const [selectors] = useDeviceSelectors()
  const { draft, setOpenedDraft, openedDraft } = props

  const openDraftMessage = async (event, messageId) => {
    event.preventDefault()
    event.stopPropagation()
    // SEND HERE messageId too
    WritingModalService.openDraft()
    DraftManagerService.switchDraftMessage(messageId)
  }

  const deleteDraftMessage = async (event, messageId) => {
    event.preventDefault()
    event.stopPropagation()
    await DraftManagerService.deleteDraftByMessageId(messageId)
  }

  return <div className={classNames('draft-list-item', { open: openedDraft === draft.id })} key={draft.id} onClick={() => setOpenedDraft(draft.id)}>
    <div className="top-header">
      <div className="top-header-left">
        <div className="subject-title">{draft.subject || 'No subject'} </div>
      </div>
      <div className="top-header-right">
        {!selectors.isAndroid && <div className='action'>
          <PencilIcon style={{ width: '18px', height: '18px' }} onClick={(event) => openDraftMessage(event, draft.id)}/>
        </div> }
        <div className='action'>
          <TrashIcon style={{ width: '18px', height: '18px' }} onClick={(event) => deleteDraftMessage(event, draft.id)}/>
        </div>
      </div>
    </div>
    <div className="bottom-header">
      <div className="bottom-header-left">
        <div className="message-info">
          { draft.tos?.length > 0
            ? <div className="recipients">
              <b>To: </b> {draft.tos.map((to) => `${to} `)}
            </div>
            : <div className="recipients">No recipients</div>
      }
          { draft.from
            ? <div className='from'>
              <b>From: </b>{`${draft.from}@${sessionService.getMe().me.defaultdomain}`}
            </div>
            : <div className='from'>
              <b>No box</b>
            </div>
        }
        </div>
    
      </div>
      <div className="bottom-header-right">
        <div className="date">
          <HumanTime date={draft.updatedAt}/>
        </div>
      </div>
    </div>
    { draft.messageHTML && <div className="draft-body">
      <div className="-summary">
        {// eslint-disable-next-line
    <MainSectionHTML html={draft.messageHTML || ''}/>
    }
      </div>
    </div>
}
    <MessageAttachmentsSection attachments={draft?.attachments}/>

  </div>
}

export function DraftList () {
  const [drafts, setDrafts] = useState(DraftManagerService.getStoredLastDrafts())
  const [isBottomMenuHidden, setIsBottomMenuHidden] = useState(false)
  const [viewType, setViewType] = useState('normal')
  const [openedDraft, setOpenedDraft] = useState('')
  const {
    scrollY,
    lastScrollTop
  } = useScroll()

  useEffect(() => {
    if (!commonsService.isMobile()) { return }
    if (!isBottomMenuHidden && scrollY > 120 && lastScrollTop < scrollY) {
      store.commit('BOTTOM_MENU:HIDE')
      setIsBottomMenuHidden(true)
    } else if (isBottomMenuHidden && lastScrollTop > scrollY) {
      store.commit('BOTTOM_MENU:SHOW')
      setIsBottomMenuHidden(false)
    }
  }, [scrollY])

  useEffect(() => {
    store.on('DRAFTS_LIST:UPDATE', () => {
      setDrafts(DraftManagerService.getStoredLastDrafts())
    })
  }, [])

  const changeViewType = (type) => {
    setViewType(type)
  }
  
  return (
    <div className={`draft-container ${viewType}`}>
      <div className="draft-header">
        <div className="draft-header-left">
          <div className="draft-list-title">Drafts</div>
        </div>
        <div className="draft-header-right">
          <ViewMenu options={[{
            label: 'normal',
            icon: <DoubleBarIcon />,
            action: () => changeViewType('normal'),
            active: true
          },
          {
            label: 'dense',
            action: () => changeViewType('dense'),
            icon: <BarsIcon />
          }
          ]} />
        </div>
      </div>
      { Object.values(drafts).length > 0
        ? <section className="draft-list">
          { Object.values(drafts)
            .filter(draft => draft?.type !== 'reply')
            .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
            .map(draft => <DraftListItem draft={draft} setOpenedDraft={setOpenedDraft} openedDraft={openedDraft} key={draft.id} />)}</section>
        : <div>
          <NoMessagesComponent/>
        </div>}
    </div>
  )
}
